import { useState, type FormEvent } from 'react';
import { post } from '../api.js';

export function SetupPage({ onComplete }: { onComplete: () => Promise<void> }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    setBusy(true);
    setError('');
    try {
      await post('/auth/setup/exchange', {
        kind: 'bootstrap',
        bootstrap_token: data.get('bootstrap_token'),
        organization_name: data.get('organization_name'),
        email: data.get('email'),
        display_name: data.get('display_name'),
        password: data.get('password')
      });
      await onComplete();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Setup failed');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="center-screen auth-background">
      <form className="panel auth-panel" onSubmit={(event) => void submit(event)}>
        <span className="eyebrow">Первый запуск</span>
        <h1>Настройка UAW</h1>
        <p>Создайте локальную организацию и администратора. Bootstrap‑секрет находится в `.env` сервера.</p>
        {error && <p className="error-box" role="alert">{error}</p>}
        <label>Организация<input name="organization_name" required maxLength={200} defaultValue="sobe.dev" /></label>
        <label>Ваше имя<input name="display_name" required maxLength={200} autoComplete="name" /></label>
        <label>Email<input name="email" required type="email" autoComplete="email" /></label>
        <label>Пароль<input name="password" required type="password" minLength={12} maxLength={256} autoComplete="new-password" /></label>
        <label>Bootstrap‑секрет<input name="bootstrap_token" required type="password" minLength={32} autoComplete="off" /></label>
        <button className="button primary full" disabled={busy}>{busy ? 'Создаём…' : 'Создать администратора'}</button>
      </form>
    </div>
  );
}

export function LoginPage({ onComplete }: { onComplete: () => Promise<void> }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    setBusy(true);
    setError('');
    try {
      await post('/auth/login', { email: data.get('email'), password: data.get('password') });
      await onComplete();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Login failed');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="center-screen auth-background">
      <form className="panel auth-panel" onSubmit={(event) => void submit(event)}>
        <span className="brand-mark large">U</span>
        <h1>Unified Agentic Workspace</h1>
        <p>Командная диспетчерская для локальных ИИ‑агентов.</p>
        {error && <p className="error-box" role="alert">{error}</p>}
        <label>Email<input name="email" required type="email" autoComplete="email" autoFocus /></label>
        <label>Пароль<input name="password" required type="password" autoComplete="current-password" /></label>
        <button className="button primary full" disabled={busy}>{busy ? 'Входим…' : 'Войти'}</button>
      </form>
    </div>
  );
}
